import { Body, Tooltip } from '@panwds/react-ui'
import { ExclamationCircleIcon } from '@panwds/icons'

const SerialNumberRenderer = ({ row, value }) => {
  const { original: { disableReason } = {} } = row
  return <>
    <div className='tw-truncate tw-h-full'>
      {disableReason ? <div className='tw-truncate tw-flex tw-items-center tw-gap-1'>
        <Body size="lg">{value}</Body>
        <Tooltip label={disableReason}>
          <ExclamationCircleIcon size='sm' className='cm-text-icon-red'/>
        </Tooltip> </div> : <Body size='lg'>{value}</Body>
      }
    </div>
  </>
}

SerialNumberRenderer.propTypes = {}
export default SerialNumberRenderer
